@use "../../../../globals/settings";
@use "../../../../globals/bcp";
@use "../../../../globals/libs/hy.core.css/layout/page-row";

:host {
  box-sizing: border-box;
  display: flex;
}

.o-header__search {
  .m-search-form {
    transition: none;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    display: none;
  }

  &.is-open {
    .m-search-form {
      @include bcp.z-index("search", 1);
      display: block;
      opacity: 1;
    }
  }
}

.m-search-form__inner {
  @include page-row.page-row;

  @include bcp.respond-lte(tabletp) {
    padding-left: 0;
    padding-right: 0;
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
/* stylelint-disable no-duplicate-selectors */
@include bcp.theme("ivt") {
  .o-header__search {
    .m-search-form {
      --button-integrated-background-color: #4b4b4b;
      --button-integrated-hover-background-color: #004889;
    }
  }
}

@include bcp.theme("buderus") {
  .o-header__search {
    .m-search-form {
      //--button-integrated-background-color: bcp.colorVar("tt-button-integrated-bg");
      --button-integrated-background-color: #434242;
    }
  }
}

@include bcp.theme("vulcano") {
  .o-header__search {
    .m-search-form {
      @include bcp.set-css-var(tt-inp, bg, settings.$brand-main35);
    }
  }
}
